import { Table, Image, Card } from "antd";
import { LuShip } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { PiWarning } from "react-icons/pi";
import "../style.scss"
function SensorTable(props: any) {

  

  const columns = [
    {
      title: "Digital Twin ID",
      dataIndex:"digital_twin_id",
      key: "id"
    //   width: 318,
      // render:(data:any)=>(
      //   <div className="d-flex gap-4 align-items-center">
      //       <div style={{backgroundColor:data?.color}} className="color-code-view-table"></div>
      //       {`${data?.senser_code}`}
      //   </div>
      // )
    },
    {
      title: "TimeStamp",
      dataIndex:"time_stamp",
      key: "id",
    //   width: 318
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "id",
    //   width: 318,
    },
    {
      title: "key",
      dataIndex: "key",
      key: "id",
    //   width: 318,
    },
    {
      title: "Value",
      dataIndex:"value",
      key: "id",
    //   width: 176,
    },
    {
      title: "Unit",
      dataIndex:"unit",
      key: "id",
    //   width: 176
    }
  ];

  const components = {
    header: {
      cell: ({ className, children, ...restProps }:any) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#087EA4',
            color:"#FFFFFF",
            fontSize:14,
            fontFamily:"Inter-SemiBold" ,
            textAlign:'center'   
          }}
          className="measurement-table-header"
        >
          {children}
        </th>
      ),
    },
    body: {
        cell: ({ className, children, ...restProps }: any) => (
          <td
            {...restProps}
            style={{
              backgroundColor: '#FFFFFF', 
              color: '#000000',              
              fontSize: 14,               
              fontFamily: 'Inter-Regular' ,
            //   textAlign:'center'
            }}
            className={className} 
          >
            {children}
          </td>
        ),
      },
  };

  
  return (
    <Card className="graph-view-container">
      <Table
        size="small"
        dataSource={props?.data}
        columns={columns}
        loading={props?.loading}
        components={components}
        pagination={false}
      />
    </Card>
  );
}

export default SensorTable;
